<template>
	<div v-if="sol != null" class="cnt-tabdesc">
		<table class="table table-bordered no-margin">
			<tbody>
				<tr>
					<th style="width: 80px">Colaborador:</th>
					<td>{{ sol.matricula.nome }} - {{ sol.matricula.mat }}</td>
					<th style="width: 100px">Data Coleta:</th>
					<td class="no-padding" style="width: 80px">
						<input
							type="date"
							v-model="sol.coleta"
							@change="updateDataColeta"
							class="form-control"
						/>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>
<script>
	import gstDate from 'js/date';
	import WBS from 'js/http';
	import toastr from 'toastr';
	export default {
		props: ['sol', 'exams'],
		inject: ['assets'],
		filters: {
			operacao(val) {
				const values = {
					I: 'Inclusão',
					A: 'Alteração',
				};
				return values[val];
			},
			resultados(val) {
				const values = {
					A: 'Admissional',
					D: 'Demissional',
					P: 'Periódico',
					E: 'Especial',
					M: 'Mudança de Função',
					R: 'Retorno ao Trabalho',
					S: 'Supletiva',
				};
				return values[val];
			},
			convocacao(val) {
				return gstDate(val, 'xmlg de YY');
			},
		},
		methods: {
			updateDataColeta(ev) {
				this.sol.coleta = ev.target.value;
				const sData = { cod: this.sol.cod, coleta: ev.target.value };
				WBS.send(
					'private-save-updateDataColetaSD2000',
					sData,
					(resp) => {
						if (resp.status == 'success' && resp.data) {
							// toastr.success("Data de Coleta alterada com sucesso!")
							this.exams.forEach((item) => {
								item.status = 1;
								const indexData = item.linhas.findIndex(
									(litem) => litem.campo == 10
								);
								if (indexData != -1) {
									item.linhas[indexData].value =
										ev.target.value;
								}
							});
						} else {
							console.log(resp);
							toastr.error(resp.msgs[0]);
						}
					}
				);
			},
		},
	};
</script>
<style scoped>
	.cnt-tabdesc {
		background-color: #f4f4f45c;
	}
</style>



// WEBPACK FOOTER //
// src/components/sd2000/solicitacoes/mdExams/header.vue